import { Link } from '@tanstack/react-router';

export function NotFoundComponent() {
  return (
    <div className="grid h-full place-items-center p-6 text-center">
      <div>
        <h2 className="text-lg font-semibold text-fg">Page not found</h2>
        <p className="mt-1 text-sm text-muted">The page you’re looking for doesn’t exist.</p>
        <Link to="/groups" className="mt-4 inline-block text-sm text-fg underline">
          Back to groups
        </Link>
      </div>
    </div>
  );
}
